<div class="single-ticket">
    <!--style="margin-top:20px;" IT CAN BE APPLIED THIS WAY ALWAYS SO ACCORDING TO CASE YOU CAN ADD THE CLASS .margin-top-20-->
    <div class="single-ticket__content">
        <div class="border-line" [ngClass]="{ renew: ticket.renewable }"></div>
        <div class="single-ticket__top-content">
            <div class="single-ticket-left-content">
                <div class="single-ticket-left-content__items">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_ZONE' | translate }}</span>
                    <span class="description">
                        {{ getZones() }}
                        <a
                            class="inline-secondary-description item-link link--emphasized link--action"
                            *ngIf="env.TICKET_HAS_ZONE_MODAL"
                            (click)="showZoneModal()">
                            {{ 'CHOOSE_STOPS_CONSULT_MAP' | translate }}
                        </a>
                        <ridango-trip-message
                            *ngIf="ticket.trip_messages?.length > 0"
                            [messages]="ticket.trip_messages"
                            [locale]="locale"></ridango-trip-message>
                    </span>
                </div>

                <div class="single-ticket-left-content__items">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_VALIDITY' | translate }}</span>
                    <span class="description" *ngIf="ticket.starting">
                        {{ ticketValidityRange | ridangoDateTime: ridangoDateTimeValidityOptions }}
                    </span>
                    <span
                        class="description"
                        *ngIf="ticket.units && ticket.initial_units && ticket.units !== ticket.initial_units">
                        {{ ticket.units | i18nPlural: bookletUnitsMapping | translate: ticket }}
                    </span>
                    <span
                        class="description"
                        *ngIf="
                            !ticket.starting &&
                            (!ticket.units || !ticket.initial_units || ticket.units === ticket.initial_units)
                        ">
                        <ng-template *ngIf="isActivatedAtPurchase; then showBlock; else notShowBlock"></ng-template>
                        <ng-template #showBlock>{{ 'TICKET_SUMMARY_V2_VALID_FROM_PURCHASE' | translate }}</ng-template>
                        <ng-template #notShowBlock>{{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}</ng-template>
                    </span>
                    <!-- <span class="description">08:05 › 10:00 <span class="date">Wed 19.09.2018</span></span> -->
                </div>
            </div>

            <div class="single-ticket-right-content">
                <div class="single-ticket-left-content__items full-width">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_PRICE' | translate }}</span>
                    <span class="description" *ngIf="!ticket.price && ticket.product_price_object?.price">
                        {{ ticket.product_price_object.price | moneyFormat }}
                        {{ appStartupService.getCurrency() | translate }}
                    </span>
                    <span
                        class="description"
                        *ngIf="!ticket.price && !ticket.product_price_object && ticket.product?.price">
                        {{ ticket.product.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                    </span>
                    <span class="description" *ngIf="ticket.price">
                        {{ ticket.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                    </span>
                </div>
            </div>
        </div>

        <div class="single-ticket-left-content remove-padding-margin-border">
            <div class="single-ticket-left-content__items">
                <span class="title">
                    <span>{{ 'TICKET_SUMMARY_V2_TICKET_TYPE' | translate }}</span>
                    <span *ngIf="ticket.amount">&middot; {{ 'TICKET_AMOUNT' | translate }}</span>
                </span>
                <span class="secondary-description">
                    <span>
                        {{
                            ticket.product ?? ticket.product_object ?? ticket
                                | translateObjectField: 'name' : locale : 'product_name'
                        }}
                    </span>
                    <span *ngIf="ticket.amount">&middot; {{ ticket.amount }}</span>
                </span>
            </div>

            <div class="single-ticket-left-content__items">
                <span class="title">
                    <span class="inline-title">{{ getMediumType() | translate }}</span>
                </span>
                <!-- <span class="inline-secondary-description">Person with disabilities</span> <span class="dash">-</span>
                <span class="inline-secondary-description">123456789</span> -->
                <span
                    class="inline-secondary-description"
                    class="inline-secondary-description"
                    *ngIf="ticket.travellerCategory">
                    {{ ticket.travellerCategory | translateObjectField: 'name' : locale }}
                </span>
                <span class="dash" *ngIf="ticket.travellerCategory">-</span>
                <span class="inline-secondary-description" *ngIf="getMedium()">{{ getMedium() }}</span>
                <span
                    class="inline-secondary-description"
                    *ngIf="!ticket.travellerCategory && !getMedium() && !isVoucher()">
                    {{ 'CHOOSE_MEDIUM_BELOW' | translate }}
                </span>
                <span class="inline-secondary-description" *ngIf="isVoucher()">{{ 'ON_VOUCHER' | translate }}</span>
            </div>
        </div>

        <div class="single-ticket-right-content remove-padding-margin-border">
            <ridango-ticket-actions-dropdown
                *ngIf="!useInputActions && ticket.actions && ticket.actions.length !== 0"
                [actions]="ticket.actions"
                [type]="'REGULAR'"
                [locale]="locale"
                [showDropdownAlways]="showActionDropdownAlways"
                (actionClicked)="actionClicked($event, ticket)"></ridango-ticket-actions-dropdown>
            <ridango-ticket-actions-dropdown
                #ticketActionsEl
                *ngIf="useInputActions"
                [actions]="actions"
                [type]="'REGULAR'"
                [locale]="locale"
                (actionClicked)="actionClicked($event, ticket)"></ridango-ticket-actions-dropdown>
        </div>
        <!--Email notification in shopping cart -->
        <div class="item-notification table" *ngIf="ticket.notifications">
            <div class="row-items table-content odd" *ngFor="let notification of ticket.notifications?.selected">
                <div class="col-item ticket-type">
                    <div>
                        <span class="arrow"><img src="assets/icon_arrow.png" alt="" /></span>
                        {{ notification.label | translate }}
                    </div>
                </div>
                <div class="col-item ticket-card-email">
                    <span>{{ ticket.email }}</span>
                </div>
            </div>
        </div>
        <!--End-->
        <!--Email notification in active tickets -->
        <!-- <div class="table item-notification" *ngIf="ticket.ticket_info && !ticket.notifications">
            <div class="row-items table-content odd">
                <div class="col-item ticket-type">
                    <div><span class="arrow"><img src="assets/icon_arrow.png" alt=""></span>
                        {{'LOCAL_EMAIL_WHEN_ENDING' | translate}}
                    </div>
                </div>
                <div class="col-item ticket-card-email"><span>{{ticket.ticket_info}}</span>
                </div>
            </div>
        </div> -->
        <!--End-->
    </div>
</div>
